import { IconWithText } from 'common/icon/icon-with-text.js';
import { ILocationSummary } from 'types/markerTypesV1/marker-v1-view-type.js';
import { getFavouriteLocationIcon } from './searchbar-fav-location-icon.js';

export const SearchbarFavouriteLocation = ({
  favourite,
  children,
}: {
  favourite: ILocationSummary;
  children: JSX.Element;
}) => {
  const iconName = getFavouriteLocationIcon(favourite);
  if (!iconName) {
    return (
      <div className="u-flex u-flexRow">
        <div className="SearchBar-favourites-list-item-text small u-textTruncate">
          <span className="u-textBold u-pR-xs">{favourite.label}</span>
        </div>
        {children}
      </div>
    );
  }

  return (
    <div data-comp="fav-location-body">
      <IconWithText
        icon={iconName}
        classes="IconWithText--vCenter"
        contentClass="u-flex u-flexRow"
        iconClass="svg-fill-textSlate"
      >
        <div className="SearchBar-favourites-list-item-text small u-textTruncate">
          <span className="u-textBold u-pR-xs">{favourite.label}</span>
        </div>
        {children}
      </IconWithText>
    </div>
  );
};
